import {deserializeAs} from 'cerialize';

export class Address {

  @deserializeAs('street')
  street: string;

  @deserializeAs('postal_code')
  postalCode: string;

  @deserializeAs('city')
  city: string;

  toString(): string {
    return this.street + ', ' + this.postalCode + ' ' + this.city;
  }

}
